import { Action } from '../../common/actions/core/action';
import { PackageThumbnail } from '../../common/services/package/package.model';

export class OpenDoubleOptDialogAction implements Action {
  constructor(
    public onSuccess: (packageData) => any,
    public onError: (error) => any,
    public onTimeOut: () => any,
    public packageData: PackageThumbnail,
    public paymentMethodId?: number,
    public cardId?:string
  ) {}
}



// WEBPACK FOOTER //
// src/app/components/double-opt-dialog/double-opt-dialog.action.ts